"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Components = require("../../Components");

var _Elements = require("../../Components/Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Option = function Option(_ref) {
  var label = _ref.label,
      subLabel = _ref.subLabel,
      value = _ref.value,
      _onClick = _ref.onClick,
      checked = _ref.checked,
      id = _ref.id,
      active = _ref.active,
      index = _ref.index,
      modifySubstring = _ref.modifySubstring,
      toggle = _ref.toggle,
      OptionPreview = _ref.OptionPreview,
      className = _ref.className;
  // Ensure focus for accessibility
  var accessibilityRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (active) {
      var _accessibilityRef$cur;

      // eslint-disable-next-line no-unused-expressions
      accessibilityRef === null || accessibilityRef === void 0 ? void 0 : (_accessibilityRef$cur = accessibilityRef.current) === null || _accessibilityRef$cur === void 0 ? void 0 : _accessibilityRef$cur.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [active]);
  return /*#__PURE__*/_react["default"].createElement(_Elements.StyledDropdownOption, {
    className: className,
    ref: accessibilityRef,
    active: active,
    id: id,
    checked: checked,
    "aria-selected": checked ? 'true' : undefined,
    role: "option",
    onClick: function onClick(e) {
      e.preventDefault();

      _onClick({
        checked: checked,
        index: index,
        optionValue: value
      });

      toggle();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    label: label,
    modifySubstring: modifySubstring,
    OptionPreview: OptionPreview
  }), subLabel ? /*#__PURE__*/_react["default"].createElement(_Components.Label, {
    className: "sublabel",
    label: subLabel
  }) : null);
};

Option.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  subLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  value: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  checked: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  modifySubstring: _propTypes["default"].func,
  toggle: _propTypes["default"].func,
  OptionPreview: _propTypes["default"].node,
  // optional element to display in label
  className: _propTypes["default"].string
};
Option.defaultProps = {
  active: false,
  modifySubstring: null,
  subLabel: null,
  onClick: null,
  checked: false,
  id: undefined,
  index: null,
  toggle: function toggle() {},
  OptionPreview: null,
  className: null
};
var _default = Option;
exports["default"] = _default;